class DataListUtils {

    closeScreen() {

        const $window = $(window);

        $window.off("scroll.changeHeaderMode scroll.notificationsList");
        baseController.closeStack();

    }

    onToggleSeachButton(event) {

        const $bigHeader = $("div.big-header");
        const $sectionHeader = $("div.section-header");
        const $bigHeaderForm = $("div.big-header > form.search-form");
        const $bigHeaderInput = $bigHeaderForm.find(".search-input");
        const $smallHeaderForm = $("div.small-header > form.search-form");
        const $smallHeaderInput = $smallHeaderForm.find(".search-input");
        const headerModes = this._dataListData.getHeaderModes();
        const headerMode = this._dataListData.getHeaderMode();
        $sectionHeader.toggleClass('search-form-opened');
        $bigHeader.toggleClass('search-form-opened');

        if (headerMode === headerModes.BIG_HEADER_MODE) {

            if ($bigHeaderForm.is(":visible")) {
                $bigHeaderForm.hide();
                $bigHeaderInput.val("");
                $smallHeaderInput.val("");
                $bigHeaderForm.trigger("submit");
            } else {
                $bigHeaderForm.show();
                $bigHeaderInput.focus();
            }

        } else {

            if ($smallHeaderForm.is(":visible")) {
                $bigHeaderForm.hide();
                $bigHeaderInput.val("");
                $smallHeaderForm.hide();
                $smallHeaderInput.val("")
                $smallHeaderForm.trigger("submit");
            } else {
                $bigHeaderForm.show();
                $smallHeaderForm.show();
                $smallHeaderInput.focus();
            }

        }

    }

    onInputChange(event) {

        const $this = $(event.currentTarget);
        const $searchInputs = $(".search-input");

        $searchInputs.val($this.val());

    }

    onClearSearch(event) {

        const $searchInput = $("section.data-list-section input.search-input");
        const $bigHeaderForm = $("div.big-header > form.search-form");
        const $bigHeaderInput = $bigHeaderForm.find(".search-input");
        const $smallHeaderForm = $("div.small-header > form.search-form");
        const $smallHeaderInput = $smallHeaderForm.find(".search-input");
        const headerModes = this._dataListData.getHeaderModes();
        const headerMode = this._dataListData.getHeaderMode();

        $searchInput.val("");

        if (headerMode === headerModes.BIG_HEADER_MODE) {
            $bigHeaderForm.trigger("submit");
            $bigHeaderInput.focus();
        } else {
            $smallHeaderForm.trigger("submit");
            $smallHeaderInput.focus();
        }

    }

    changeHeaderMode(dataListData) {

        const $window = $(window);
        const $smallHeader = $("div.small-header");
        const $smallHeaderTitle = $("div.small-header span.title");
        const $bigHeaderForm = $("div.big-header > form.search-form");
        const $smallHeaderForm = $("div.small-header > form.search-form");
        const $smallHeaderInput = $smallHeaderForm.find(".search-input");
        const $bigHeaderInput = $bigHeaderForm.find(".search-input");
        const that = this;
        const bigHeaderTitleText = $("div.big-header p.title").text();
        const bigHeaderHeight = $("div.big-header").height() - 100;
        const headerModes = dataListData.getHeaderModes();

        $window.on("scroll.changeHeaderMode", function() {

            const scrollPosition = $window.scrollTop();

            if (scrollPosition >= bigHeaderHeight && dataListData.getHeaderMode() === headerModes.BIG_HEADER_MODE) {

                dataListData.setHeaderMode(headerModes.SMALL_HEADER_MODE);
                $smallHeaderTitle.text(bigHeaderTitleText);
                $smallHeader.addClass("is-fixed");
                $smallHeader.animate({"opacity": 1}, 250);

                if ($bigHeaderForm.is(":visible")) {
                    $smallHeaderForm.show();
                    $smallHeaderInput.focus();
                }

            } else if (scrollPosition < bigHeaderHeight && dataListData.getHeaderMode() === headerModes.SMALL_HEADER_MODE) {

                dataListData.setHeaderMode(headerModes.BIG_HEADER_MODE);
                $smallHeader.animate({"opacity": 0}, 250, function() {

                    $smallHeader.removeClass("is-fixed");
                    $smallHeaderForm.hide();
                    $smallHeaderTitle.text("");

                    setTimeout(function() {

                        $smallHeader.animate({"opacity": 1}, 250, function() {
                            $smallHeader.css("opacity", "");
                        });

                    }, 250);
                });

                if ($bigHeaderForm.is(":visible")) {
                    $bigHeaderInput.focus();
                }
            }

        });

    }

    applyNotificationEllipsis(notificationsTypes) {

        function _applyEllipsis() {

            const $this = $(this);
            const notificationType = $this.data("type");

            if ([notificationsTypes.GENERIC, notificationsTypes.GENERIC_BROADCAST, notificationsTypes.IMAGE, notificationsTypes.INTERNAL_LINK].indexOf(notificationType) < 0) {

                const $activityCardTitle = $this.find("span.activity-action-title");
                const $activityCardComment = $this.find("p.activity-comment");

                $activityCardTitle.dotdotdot(dotOptions);
                $activityCardComment.dotdotdot(dotOptions);

            }

        }

        const $activityCard = $("div.activity-card.is-notification-card");
        const dotOptions = {
            height: 40,
            watch: "true",
            truncate: "letter"
        };

        $activityCard.each(_applyEllipsis);

    }

}